<template>
  <div id="terms-condition-content" class="support-content" v-html="supportContent"></div>
</template>


<script>
import supportMixins from "../../mixins/supportMixins";

export default {
  metaInfo: {
    title: "Terms of Use | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health terms of Use govern your use of this website; by using this website, you accept these Terms of Use in full. "
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone health, 1byonehealth, Terms of Use, terms,conditions"
      }
    ]
  },
  mixins: [supportMixins("TermsCondition")]
};
</script>